import { DATE_FORM_FORMAT } from '@/constants/date'
import moment from 'moment'
export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    date: moment().format(DATE_FORM_FORMAT),
    approveFrom: null,
    approveTo: null,
    balanceFrom: null,
    balanceTo: null,
    factFrom: null,
    factTo: null,
    status: null,
    advertisers: '',
    managers: '',
    partners: '',
    countries: '',
    paymentModels: '',
    offerCategories: '',
    groups: '',
  },
  sortBy: [],
  sortDesc: [],
  sortBy1: [],
  sortDesc1: [],
  sortBy2: [],
  sortDesc2: [],
  sortBy3: [],
  sortDesc3: [],
  sortBy4: [],
  sortDesc4: [],
  sortBy5: [],
  sortDesc5: [],
  clientOptions: {
    filterPanelExpanded: false,
    viewOption: 'all',
  },
})
